import { MaasRunMode } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import { parseNodesField } from '@/delivery-type-plugin/capabilities/maas-node-groups/nodeFields';

/** 服务入口节点表单字段（多选，提交时写入每条 network.service[].groupNames） */
export const SERVICE_MOUNT_GROUP_NAME_FIELD = '_serviceMountGroupName';

/** 归一化表单/API 中的入口节点为字符串数组（兼容历史单选 string） */
export function normalizeServiceMountGroupNames(value: unknown): string[] {
  if (value == null || value === '') return [];
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }
  const single = String(value).trim();
  return single ? [single] : [];
}

/** 从顶层 network.service 汇总去重后的入口节点名称 */
export function resolveServiceMountGroupNamesFromServices(services?: { groupNames?: string[] }[] | null): string[] {
  if (!Array.isArray(services) || !services.length) return [];
  const names = new Set<string>();
  for (const svc of services) {
    for (const groupName of svc.groupNames ?? []) {
      const trimmed = String(groupName).trim();
      if (trimmed) names.add(trimmed);
    }
  }
  return [...names];
}

/** 入口节点列表展示文案 */
export function formatServiceMountGroupNamesDisplay(names: string[], fallback = '-'): string {
  const normalized = names.map((name) => String(name).trim()).filter(Boolean);
  return normalized.length ? normalized.join('、') : fallback;
}

/** 按部署模式解析可选入口节点（PS：Master + Worker；Normal：仅 Worker） */
export function buildServiceMountNodeOptions(values: {
  runMode?: MaasRunMode | string;
  masterNodes?: unknown;
  workerNodes?: unknown;
}): { label: string; value: string }[] {
  const runMode = values.runMode || MaasRunMode.Normal;
  const masters = parseNodesField(values.masterNodes);
  const workers = parseNodesField(values.workerNodes);
  const isPrimarySecondary = runMode === MaasRunMode.PrimarySecondary;
  const nodes = isPrimarySecondary ? [...masters, ...workers] : workers;
  return nodes
    .map((node) => String(node?.name ?? '').trim())
    .filter(Boolean)
    .map((name) => ({ label: name, value: name }));
}
